import _ from 'lodash'
import moment from 'moment'
import { OFFER_LETTER_TEMPLATE_FIELD_TYPE } from '@/constant/company'
import { getI18nPropertyValue, isEn } from '@/i18n'

export default {
  data () {
    return {
      allTemplateFiledList: []
    }
  },
  computed: {},
  methods: {
    /**
     * 通过正则获取 content 中所有 ${key} 格式占位符并返回, 返回的 key list 不包含字符 '${}'
     * @param content string
     */
    getTemplateAllPlaceholder (content) {
      const regex = /\$\{([a-zA-Z_][a-zA-Z0-9_]*)\}/g
      let matches
      const keys = []
      // 使用exec方法循环遍历所有匹配项
      while ((matches = regex.exec(content)) !== null) {
        // 匹配结果的第一个捕获组即为key
        keys.push(matches[1])
      }
      return _.uniq(keys)
    },
    formatOfferLetterInfo (offerLetterInfo) {
      const fieldInfoValue = {}
      _.forEach(offerLetterInfo, (val, key) => {
        const field = _.find(this.allTemplateFiledList, field => field.key === key)
        if (!field) {
          fieldInfoValue[key] = val
          return
        }
        const valueType = field.value_type
        let value = val
        if (valueType === OFFER_LETTER_TEMPLATE_FIELD_TYPE.SELECT) {
          const optionList = field.option_list || []
          const selectOption = _.filter(optionList, option => _.includes(val, option.id))
          value = _.chain(selectOption).map(option => getI18nPropertyValue(option, 'name_cn', 'name_en')).join(isEn() ? ', ' : '，').value()
        } else if (valueType === OFFER_LETTER_TEMPLATE_FIELD_TYPE.SINGLE) {
          const optionList = field.option_list || []
          const selectOption = _.find(optionList, option => option.id === val)
          value = getI18nPropertyValue(selectOption, 'name_cn', 'name_en')
        } else if (valueType === OFFER_LETTER_TEMPLATE_FIELD_TYPE.DATE) {
          value = val ? moment(val).format('YYYY-MM-DD') : ''
        } else if (valueType === OFFER_LETTER_TEMPLATE_FIELD_TYPE.TEXTAREA) {
          value = val ? val.replace(/\n/g, '<br>').replace(/ /g, '&nbsp;') : ''
        }
        fieldInfoValue[key] = value
      })
      return fieldInfoValue
    },
    formatContent (content, offerLetterInfo) {
      if (!content) {
        return ''
      }
      const allKeys = this.getTemplateAllPlaceholder(content)
      const templateFields = _.chain(this.allTemplateFiledList).filter(item => _.includes(allKeys, item.key)).map(item => {
        item.order = _.findIndex(allKeys, key => key === item.key)
        return item
      }).orderBy('order').value()

      _.forEach(templateFields, field => {
        if (!_.has(offerLetterInfo, field.key)) {
          offerLetterInfo[field.key] = null
        }
      })
      const fieldInfoValue = this.formatOfferLetterInfo(offerLetterInfo)
      return content.replace(/\$\{([a-zA-Z_][a-zA-Z0-9_]*)\}/g, (placeholder, key) => {
        return _.has(fieldInfoValue, key) ? (fieldInfoValue[key] ?? '') : placeholder
      })
    }
  }
}
